import React from 'react'
import './Product.css';
import { useStateValue } from './StateProvider';

function Product(props) {
    const {id,title,image,price,rating} =props.products;
    const[{basket},dispatch]=useStateValue();
    //console.log(basket)
    const addToBasket=()=>{
        //dispatch the item into the data layer
        dispatch({
            type:'ADD_TO_BASKET',
            item:{
                id:id,
                title:title,
                image:image,
                price:price,
                rating:rating
            }
        })
    }
    return (
        <div className="product">
            <div className="product__info">
                <p>{title}</p>
                <p className="product__price">
                    <small>$</small>
                    <strong>{price}</strong>
                </p>
                <div className="product__rating">
                    {Array(rating)
                    .fill()
                    .map((_,i)=> (
                       <p>🌟</p>
                    ))}
                </div>
            </div>
            <div className="product__image">
                <img src={image} alt="product" className="img-fluid"/>
            </div>
            <button onClick={addToBasket} className="my-3">add to Basket</button>

        </div>
    )
}

export default Product
